<template>
	<div class="not-print">
	    <header>
	        <div class="content">
	            <div class="logo"><img src="./../assets/images/logo2.png" alt="logo"></div>
	            <div class="head-menu not-print">
	                <span class="" @mouseover="isUserMenuShow=true" @mouseleave="isUserMenuShow=false">
	                    {{userInfo.SupplierName}}
	                    <ul class="user-menu" v-show="isUserMenuShow">
	                        <li><a  @click="pateTo('user')">用户信息</a></li>
	                        <li><a  @click="pateTo('user?activeNav=nav2')"  v-if="!loginAsChild||loginAsChild=='false'">子账号管理</a></li>
	                        <li><a  @click="pateTo('user?activeNav=nav3')">修改密码</a></li>
	                        <li><a @click="logout">退出登录</a></li>
	                    </ul>
	                </span>
	               
	                <i class="wechat" @mouseover="isEwmShow=true" @mouseleave="isEwmShow=false">
	                    <div class="check-ewm" v-show="isEwmShow">
	                        <img src="./../assets/images/ewm.png" alt="">
	                    </div>
	                </i>
	            </div>
	        </div>
	    </header>

	    <nav class="nav-bar not-print">
	        <div class="content">
	            <ul class="nav-menu" style="display: flex;justify-content: space-evenly;">
	                <li :class="page=='/index'?'menu-item active':'menu-item'" @click="pateTo('index')">选择酒店</li>
	                <li v-if="userHasPersission(1)" :class="page=='/roomStatus'?'menu-item active':'menu-item'" @click="pateTo('roomStatus')">房态维护</li>
	                <li v-if="userHasPersission(2)" :class="page=='/roomPrice'?'menu-item active':'menu-item'" @click="pateTo('roomPrice')">房价维护</li>
	                <li v-if="userHasPersission(5)" :class="page.indexOf('roomPriceAndStatus')>-1?'menu-item active':'menu-item'" @click="pateTo('roomPriceAndStatus')">查看房价房态</li>
	                <li v-if="userHasPersission(3)" :class="page.indexOf('order')>-1?'menu-item active':'menu-item'" @click="pateTo('order')">订单处理</li>
	                <li v-if="userHasPersission(7)" :class="page.indexOf('payment')>-1?'menu-item active':'menu-item'" @click="pateTo('payments')">查看付款水单</li>
	                <!--<li  :class="page.indexOf('user')>-1?'menu-item active':'menu-item'"  @click="pateTo('user')">用户中心</li>-->
	                <li v-if="userHasPersission(20)"  :class="page.indexOf('veri')>-1?'menu-item active':'menu-item'"  @click="pateTo('veri')">预约核销</li>
	                
	                <!-- <li  class="menu-item"  ><a href="https://h.cnbooking.net/help.pdf" target="_blank">帮助文档</a></li> -->
	            </ul>
	        </div>
	    </nav>
	</div>
</template>

<script>
export default {
  	name: 'headcm1',
  	props:{
        // 多选模式1
        page: {
            type: String,
			default:function(){
	    		return 	''
	    	}
        }
  	},
  	data(){
		return{
			userInfo:JSON.parse(this.dao.get('res')),
			isUserMenuShow:false,
			isEwmShow:false,
			loginAsChild:this.dao.get('loginAsChild')
		}
  	},
  	methods:{
  		userHasPersission(pms){
			return this.userInfo.Permissions&&this.userInfo.Permissions.indexOf(pms)>-1?true:false;
  		},
  		pateTo(url){
  			this.$router.push(url);
  		},
  		logout(){

            // this.dao.set('res','');
            localStorage.clear(); 

            this.$router.push('/');
  		}

  	}


}
</script>





// WEBPACK FOOTER //
// src/components/Header.vue